<template>
    <el-dropdown trigger="click" placement="bottom">
        <span class="el-dropdown-link">
            <el-tooltip class="item" effect="dark" content="Products" placement="bottom">
                <div class="mr-0 pointer row align-items-center justify-content-center no-gutters text-white box-shadow">
                    <!-- <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/products.svg" width="30"> -->
                    <img src="/static/images/products_icon_new.png" alt="products-icon" width="25">
                </div>
            </el-tooltip>
        </span>
        <el-dropdown-menu slot="dropdown">
            <div class="d-flex justify-content-center w-220px" v-if="api_call_in_progress && filter_allProduct.length <= 0">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="text-center fw-600 py-3 w-220px" v-else-if="!api_call_in_progress && filter_allProduct.length <= 0">
                No Products Found
            </div>
            <div v-else-if="filter_allProduct.length > 0" class="dropdown-apps uk-grid uk-grid-width-medium-1-3 uk-text-center d-flex align-items-center flex-wrap">
                <a v-for="(product,index) in filter_allProduct" :key="index" :href="product.product_name == 'DigiHelp' ? 'javascript:' : product.public_url" :target="product.product_name == 'DigiHelp' ? '' : '_blank'"
                    class="logoblock px-2">
                    <div class="product-placement">
                        <i v-if="product.product_name == 'Accounting'" class="logo-accounting-bookeeping material-icons md-36 md-color-orange-600"></i>
                    </div>
                    <div>
                        <i v-if="product.product_name == 'Chat'" class="logo-chat material-icons md-36 md-color-light-green-600"></i>
                    </div>
                    <div>
                        <i v-if="product.product_name == 'DigiHRMS'" class="logo-hrms material-icons md-36 md-color-blue-600 pl-2" > </i>
                    </div>
                    <div>
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/admin.png" v-if="product.product_name == 'DigiAdmin'" class="logo-cloud material-icons md-36 md-color-orange-600 ml-2" style="width: 27px; height: 30px;"/>
                    </div>
                    <div>
                        <i v-if="product.product_name == 'CRM'" class="logo-crm material-icons md-36 md-color-light-green-600"></i>
                    </div>
                    <div>
                        <i v-if="product.product_name == 'DigiPOS'" style="font-size:20px !important" class="logo-pos material-icons md-36 md-color-blue-600"></i>
                    </div>
                    <div class="product-placement">
                        <i v-if="product.product_name == 'SCM'" style="position:relative;right:4px" class="logo-scm material-icons md-36 md-color-blue-600"></i>
                    </div>
                    <div class="mr-1 product-placement">
                        <i v-if="product.product_name == 'Forms'" class="logo-forms material-icons md-36 md-color-cyan-600"></i>
                    </div>
                    <div class="mr-1">
                        <i v-if="product.product_name == 'DigiHelp'" class="logo-help-desk material-icons md-36 md-color-blue-600"></i>
                    </div>
                    <div class="">
                        <i v-if="product.product_name == 'DigiExpense'" class="logo-expence-management material-icons mr-1 md-36 md-color-blue-600" style="font-size: 22px !important;margin-left: -5px !important;"></i>
                    </div>
                    <div class="">
                        <img src="https://cdn.digicollect.com/cdn/boardx/static/images/boardx_icon_blue.png" v-if="product.product_name == 'BoardX'" class="logo-cloud material-icons md-36 md-color-orange-600 mr-2" style="width: 27px; height: 30px;"/>
                    </div>
                    
                    <div class="">
                        <img src="https://cdn.digicollect.com/cdn/all_products_logo/blue/cloud.png" v-if="product.product_name == 'Cloud'" class="logo-cloud material-icons md-36 md-color-orange-600 mr-2" style="width: 27px; height: 30px;"/>
                    </div>

                    <span v-if="product.product_name.includes('Digi')" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">{{product.product_name}}</span>
                    <span v-else-if="product.product_name == 'BoardX'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">{{product.product_name}}</span>
                    <span v-else class="uk-text-muted uk-display-block new-blue mt-2 fw-500">{{'Digi'+product.product_name}}</span>
                    <!-- <span v-if="product.product_name == 'Accounting'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiAccounting</span>
                    <span v-if="product.product_name == 'DigiAdmin'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiAdmin</span>
                    <span v-if="product.product_name == 'Chat'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiChat</span>
                    <span v-if="product.product_name == 'DigiHRMS'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500 pl-1">DigiHRMS</span>
                    <span v-if="product.product_name == 'CRM'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiCRM</span>
                    <span v-if="product.product_name == 'DigiPOS'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiPOS</span>
                    <span v-if="product.product_name == 'SCM'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiSCM</span>
                    <span v-if="product.product_name == 'Forms'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiForms</span>
                    <span v-if="product.product_name == 'DigiHelp'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500">DigiHelp</span>
                    <span v-if="product.product_name == 'DigiExpense'" class="uk-text-muted uk-display-block new-blue mt-2 fw-500" style="margin-left: 6px !important;">DigiExpense</span> -->
                    <hr>
                </a>
            </div>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import global from '../global';
import crm from "../mixins/crm.js"
export default {
    mixins:[crm],
    data(){
        return{
            allProduct:[],
            purchased_product:[],
            search_key:'',
            filter_purchased_product:[],
            filter_allProduct:[],
            value:false,
            api_call_in_progress:false,
        }
    },
    methods:{
        async getAllDigiProducts(){
            this.api_call_in_progress = true;
            try {
                // let res = await this.$http.get(global.AUTH_SERVICE + `/company/products/subscribed/get?company_id=${this.loggedInUserCompanyId}`);
                // if(res.data.status_id == 1){
                //     if(res.data.products_list.length > 0){
                //         this.filter_allProduct = res.data.products_list;
                //         this.api_call_in_progress = false;
                //     }
                // }
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: ""
                }
                let res = await this.$http.get(global.ADMIN_API + `/products/list?skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`);
                if (res.data.status_id == 1) {
                    // this.productsList = res.data.response;
                    this.filter_allProduct = res.data.response;
                    this.api_call_in_progress = false;
                }
            } catch (reason) {
                console.log(reason)
            }
        },
    },
    computed:{
        loggedInUser() {
            return this.$store.state.loggedInUser
        },
        loggedInUserCompanyId() {
            return this.$store.state.loggedInUserCompanyId
        }
    } ,
    async mounted(){
        this.api_call_in_progress = true;
            this.getAllDigiProducts()    
        }
}
</script>
<style scoped>
.header{
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.dropdown-apps {
    width: 240px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.uk-margin-bottom {
    margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
    content: "";
    display: block;
    overflow: hidden;
}
[class*="uk-grid-width"] > * {
    box-sizing: border-box;
    width: 100%;
}
.uk-grid-width-medium-1-3 > * {
     width: 33.333%;
}
.uk-margin-top {
    margin-top: 15px !important;
}
.uk-grid > * {
    -webkit-box-flex: 0;
    flex: none;
    margin: 0;
    width: 100%;
    padding: 5px 10px 7px 17px;
    border-bottom: solid 1px #cce3fc;
    float: left;
    text-align: center;
    text-decoration: none;
    display: flex !important;
    line-height: 22px;
}
.uk-grid > *:last-child {
    border-bottom: solid 0px transparent;
}
.uk-grid > *:hover {
    text-decoration: none;
    background: #cce3fc !important;
}
i.material-icons.md-36 {
    font-size: 23px !important;
    line-height: 36px !important;
    height: 36px !important;
    width: 36px !important;
    padding-bottom: 15px;
    color: #00448b !important;
}
.uk-grid > * > :last-child {
    margin-bottom: 0;
}
@media (min-width: 1220px) {
    .uk-grid > * {
        padding-left: 0px;
    }
}
.uk-text-muted {
    color: #005dae !important;
}
.uk-display-block {
    display: block !important;
}
.logoblock .uk-display-block {
    margin-top: 8px;
    position: relative;
    left: 20px;
}
div.title.h6 {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #00448b;
}
.border-img {
    width: 202px;
    height: 2px;
    object-fit: contain;
    border-radius: 19px;
    padding-left: 10px;
    margin-bottom: 5px;
}
.headerproducts {
    padding: 5px 10px 0px 10px;
}
.viewtxt {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.5px;
    color: #303031;
    padding-right: 6px;
}
.search-group {
    margin-bottom: 0px;
    padding: 10px 10px;
}
.input-search {
    position: relative;
}
.input-search .input-search-close, .input-search .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.input-search .input-search-icon {
    left: 0px;
    font-size: 16px;
    color: #00448b;
    text-align: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
}
.input-search .input-search-icon+.search-control {
    padding-left: 2.4rem;
}
.search-control:focus + .input-search .input-search-icon {
    color: #00448b !important;
}
.search-control {
    height: 2.573rem;
    -webkit-appearance: none;
    border-color: #005dae;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -o-transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -moz-appearance: none;
}
.search-control {
    display: block;
    width: 100%;
    padding: .429rem 1.072rem;
    font-size: 14px;
    line-height: 1.571429;
    color: #303031;
    background-color: #fff;
    background-image: none;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-bottom: 1px solid #cdd2da !important;
    border-radius: 0px;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    overflow: visible;
    margin: 0;
}
.search-control:focus {
    border-color: #005dae !important;
}
button.input-search-close {
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}
.input-search-close.icon {
    font-size: 16px;
    line-height: 16px;
}
.input-search .input-search-close {
    right: 8px;
}
.product-placement{
    position: relative;
    left: 6px;
}

.dropdown-apps {
    width: 220px !important;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.w-220px{
    width: 220px !important;
}
</style>
